module.exports = __webpack_public_path__ + "assets/Mu.694fa4f6f427706f2afdff4e3c488630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Mu.png
// module id = 790
// module chunks = 0